/** Zoom level below which zone-mission features (cores, waypoint snaps, dumps) are hidden. */
export const HIDE_AT_ZOOM_ZONE = 14;

/** Zoom level below which grid-mission features (cores, waypoint snaps, dumps) are hidden. */
export const HIDE_AT_ZOOM_GRID = 20;

/** Zoom level below which feature text labels are hidden. */
export const HIDE_TEXT_ZOOM = 16;

/** Returns the appropriate hideAtZoom value based on mission type. */
export function hideAtZoom(zoneMission: boolean): number {
  return zoneMission ? HIDE_AT_ZOOM_ZONE : HIDE_AT_ZOOM_GRID;
}
